import {
    getAppVersion,
    getDeviceNameOS,
    getDeviceUniqueId,
    getPlatform,
} from '../../utils/deviceInfo';
import { CRMAPIBase } from '../crmApiBase';
import { RequestResult } from '../responseModels/requestResult';
import { ConnectionResp } from '../responseModels/security/connectionResponse';
import { LoginResp } from '../responseModels/security/loginResponse';
import { RegistrationResp } from '../responseModels/security/registrationResponse';

class SecurityGroup extends CRMAPIBase {
    /**
     * Запрос на наличие пользователя в БД с таким номером телефона
     * @param phone Номер телефона
     * @returns Результат запроса
     */
    async connection(phone: string): Promise<RequestResult<ConnectionResp>> {
        const result = await this.post<ConnectionResp>('/security/connection', { phone: phone });
        return result;
    }

    /**
     * Запросить код
     * @param phone Номер телефона
     * @returns Результат запроса
     */
    async sendCode(phone: string): Promise<RequestResult<any>> {
        const result = await this.post<any>('/security/sendCode', { phone: phone });
        return result;
    }

    /**
     * Логин
     * @param phone Номер телефона
     * @param passcode Код входа
     * @returns Результат запроса
     */
    async login(phone: string, passcode: string): Promise<RequestResult<LoginResp>> {
        // Заголовки:
        // X-Device-UID - уникальный идентификатор устройства (UUID + fingerprint)
        // X-App-Version - версия приложения (например: "WEB-0.0.1")
        // X-Device-OS-Name - название операционной системы
        // X-Device-OS-Version - версия операционной системы
        // X-Device-Platform - название браузера
        this._token = null;
        delete this._httpClient.defaults.headers.common['Authorization'];

        // Получаем информацию об устройстве
        const deviceNameOS = getDeviceNameOS();
        const platform = getPlatform();
        const deviceOSVersion = getAppVersion();
        const deviceUID = getDeviceUniqueId();

        console.log('=== Device Information ===');
        console.log('X-Device-UID:', deviceUID);
        console.log('X-App-Version: WEB-0.0.1');
        console.log('X-Device-OS-Name:', deviceNameOS);
        console.log('X-Device-OS-Version:', deviceOSVersion);
        console.log('X-Device-Platform:', platform);
        console.log('=========================');

        const result = await this.post<LoginResp>(
            '/security/login',
            {
                phone: phone,
                passcode: passcode,
            },
            null,
            {
                'X-Device-UID': deviceUID,
                'X-App-Version': 'WEB-0.0.1',
                'X-Device-OS-Name': deviceNameOS,
                'X-Device-OS-Version': deviceOSVersion,
                'X-Device-Platform': platform,
            }
        );
        if (!result.errorMessages) {
            this._token = result.data.token;
            this._httpClient.defaults.headers.common['Authorization'] = 'Bearer ' + this._token;
        }
        return result;
    }

    /**
     * Регистрация
     * @param phone Номер телефона
     * @param passcode Код входа
     * @returns Результат запроса
     */
    async register(phone: string, passcode: string): Promise<RequestResult<RegistrationResp>> {
        // Заголовки:
        // X-Device-UID - уникальный идентификатор устройства
        // X-App-Version - версия приложения
        // X-Device-OS-Name - название операционной системы
        // X-Device-OS-Version - версия операционной системы
        // X-Device-Platform - название браузера
        this._token = null;
        delete this._httpClient.defaults.headers.common['Authorization'];

        // Получаем информацию об устройстве
        const deviceNameOS = getDeviceNameOS();
        const platform = getPlatform();
        const deviceOSVersion = getAppVersion();
        const deviceUID = getDeviceUniqueId();

        console.log('=== Device Information (Register) ===');
        console.log('X-Device-UID:', deviceUID);
        console.log('X-App-Version: WEB-0.0.1');
        console.log('X-Device-OS-Name:', deviceNameOS);
        console.log('X-Device-OS-Version:', deviceOSVersion);
        console.log('X-Device-Platform:', platform);
        console.log('=====================================');

        const result = await this.post<RegistrationResp>(
            '/security/register',
            {
                phone: phone,
                passcode: passcode,
            },
            null,
            {
                'X-Device-UID': deviceUID,
                'X-App-Version': 'WEB-0.0.1',
                'X-Device-OS-Name': deviceNameOS,
                'X-Device-OS-Version': deviceOSVersion,
                'X-Device-Platform': platform,
            }
        );
        if (!result.errorMessages) {
            this._token = result.data.token;
            this._httpClient.defaults.headers.common['Authorization'] = 'Bearer ' + this._token;
        }
        return result;
    }

    /**
     * Закрытие сессии
     * @param CRMID Идентификатор текущей CRM
     * @returns Результат запроса
     */
    async logout(CRMID: number): Promise<RequestResult<any>> {
        this._token = null;
        const result = await this.get<any>('/security/logout', { crm_id: CRMID });
        return result;
    }

    async setToken(token: string) {
        this._token = token;
        this._httpClient.defaults.headers.common['Authorization'] = 'Bearer ' + this._token;
    }
}

export { SecurityGroup };
